import React from "react";
import LinearProgress from "@mui/material/LinearProgress";

export default class VisitProgress extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <h3 style={{ textAlign: "center" }}>
          Step {this.props.questionNumber} of {this.props.totalQuestions}
        </h3>
        <LinearProgress
          color="secondary"
          variant="determinate"
          style={{ height: "6px" }}
          value={
            this.props.questionNumber * (100.0 / this.props.totalQuestions)
          }
        />
      </React.Fragment>
    );
  }
}
